import React from "react";
import { BordaModalProps } from "../types";

const BordaModal: React.FC<BordaModalProps> = ({
  isOpen,
  selectedPizza,
  bordas,
  isLoading = false,
  isCreatingProducao = false,
  selectedBorda,
  onBordaSelect,
  onCancel,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm">
      <div className="relative w-full max-w-lg overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-black/5">
        <div className="bg-primary px-6 py-5 text-center">
          <span className="mb-2 block text-4xl">🍕</span>
          <h3 className="text-xl font-bold tracking-tight text-white">
            Escolha a borda
          </h3>
          <p className="mt-1 text-sm text-white/85">
            Qual borda você quer nesta pizza?
          </p>
        </div>

        <div className="px-6 py-5">
          <div className="mb-5 flex justify-center">
            <span className="inline-flex items-center rounded-full bg-error-light px-4 py-1.5 text-sm font-semibold text-primary">
              {selectedPizza}
            </span>
          </div>

          {isLoading ? (
            <div className="py-8 text-center text-neutral-600">
              Carregando bordas...
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-3">
              {bordas.map((borda) => {
                const isSelected = selectedBorda === borda.id;
                return (
                  <button
                    key={borda.id}
                    onClick={() => onBordaSelect(borda.id)}
                    type="button"
                    className={`group flex items-center justify-between rounded-xl border-2 px-4 py-3.5 text-left transition-all duration-200 ${
                      isSelected
                        ? "border-primary bg-error-light shadow-md"
                        : "border-neutral-200 bg-neutral-50/50 hover:border-neutral-300 hover:bg-neutral-100 hover:shadow-sm"
                    }`}
                  >
                    <span
                      className={`font-medium ${
                        isSelected ? "text-primary" : "text-neutral-800"
                      }`}
                    >
                      {borda.nome}
                    </span>
                    {isSelected && (
                      <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary text-sm font-bold text-white">
                        ✓
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          )}

          <div className="mt-6 flex gap-3">
            <button
              onClick={onCancel}
              type="button"
              className="flex-1 rounded-xl border border-neutral-300 bg-white px-4 py-3 font-medium text-neutral-600 transition-colors hover:bg-neutral-50 hover:text-neutral-800"
            >
              Cancelar
            </button>
            <button
              onClick={onConfirm}
              type="button"
              disabled={!selectedBorda || isCreatingProducao}
              className={`flex-1 rounded-xl px-4 py-3 font-semibold text-white shadow-lg transition-all disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none ${
                selectedBorda && !isCreatingProducao
                  ? "bg-primary hover:-translate-y-0.5 hover:shadow-xl"
                  : "bg-neutral-400"
              }`}
            >
              {isCreatingProducao ? "Criando produção..." : "Iniciar Produção"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BordaModal;
